import * as illustrationApi from '../../../store/illustration/api';
import { ILLUSTRATION_FEATURE_PREMIUM_FINANCING, toIllustrationLinkedId } from './utils';

export const linkIllustrationConsumer = (
  illustrationId,
  linkedId,
  feature = ILLUSTRATION_FEATURE_PREMIUM_FINANCING
) => {
  const nextIllustrationId = toIllustrationLinkedId(illustrationId);
  const nextLinkedId = toIllustrationLinkedId(linkedId);
  if (!nextIllustrationId || !nextLinkedId) return Promise.resolve();
  return illustrationApi.linkIllustration(nextIllustrationId, { feature, linkedId: nextLinkedId }).catch(() => {});
};

export const unlinkIllustrationConsumer = (
  illustrationId,
  linkedId,
  feature = ILLUSTRATION_FEATURE_PREMIUM_FINANCING
) => {
  const nextIllustrationId = toIllustrationLinkedId(illustrationId);
  const nextLinkedId = toIllustrationLinkedId(linkedId);
  if (!nextIllustrationId || !nextLinkedId) return Promise.resolve();
  return illustrationApi.unlinkIllustration(nextIllustrationId, { feature, linkedId: nextLinkedId }).catch(() => {});
};

/**
 * After a successful pFin version save, keep illustrations.meta.linked in sync.
 * Compare last-saved vs this-save snapshots; only original != final writes meta.linked.
 * Must not run on import/select — an unsaved version must not write meta.linked.
 * Link failures are best-effort and must not fail the save toast.
 */
export const syncPremiumFinancingIllustrationLinks = async ({ previousProfiles, nextProfiles } = {}) => {
  const prev = Array.isArray(previousProfiles) ? previousProfiles : [];
  const next = Array.isArray(nextProfiles) ? nextProfiles : [];
  const feature = ILLUSTRATION_FEATURE_PREMIUM_FINANCING;
  const prevById = new Map();
  prev.forEach(profile => {
    const id = toIllustrationLinkedId(profile?._id);
    if (id) prevById.set(id, profile);
  });

  await Promise.all(
    next.map(async profile => {
      const linkedId = toIllustrationLinkedId(profile?._id);
      if (!linkedId) return;
      const originalIllustrationId = toIllustrationLinkedId(prevById.get(linkedId)?.linkedIllustration?._id);
      const finalIllustrationId = toIllustrationLinkedId(profile?.linkedIllustration?._id);
      if (originalIllustrationId === finalIllustrationId) return;
      try {
        if (originalIllustrationId) {
          await unlinkIllustrationConsumer(originalIllustrationId, linkedId, feature);
        }
        if (finalIllustrationId) {
          await linkIllustrationConsumer(finalIllustrationId, linkedId, feature);
        }
      } catch {
        // Reverse-link is best-effort; the profile save already succeeded.
      }
    })
  );
};
